import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { useSelector } from 'react-redux';
import { selectClientCobrand } from 'features/cobrand/cobrandSlice';
import { getBrowserInfo, getDeviceType } from 'utils/deviceInfoUtils';
import { useAppStatus } from 'features/appStatus/hooks/useAppStatus';

export const SUPPORT_EMAIL_ADDRESS = 'help@wellframe.com';
export const FEEDBACK_EMAIL_SUBJECT = 'Member Web Feedback';

const usePrefilledEmailBody = () => {
  const user = useLoggedInUser();
  const clientCobrand = useSelector(selectClientCobrand);
  const appSku = clientCobrand?.sku;
  const { version } = useAppStatus();

  const metaObj: Record<string, any> = {
    'APP SKU': appSku,
    Browser: getBrowserInfo(),
    Device: getDeviceType(),
    Version: version,
  };

  if (user) {
    metaObj['Program User'] = user.id;
    metaObj.Hospital = user.hospital?.id;
    metaObj['Access Code'] = user.code;
  }

  const meta = JSON.stringify(metaObj, null, 2);

  return (
    'Please provide your feedback below. If you have screenshots, feel free to attach them to this email.\n\n' +
    '-----\n\n' +
    'The following info is included to help us track down any reported issues.\n\n' +
    `${meta}\n`
  );
};

export const useSupportMailtoLink = () => {
  const emailBody = usePrefilledEmailBody();
  return (
    `mailto:${SUPPORT_EMAIL_ADDRESS}` +
    `?subject=${encodeURIComponent(FEEDBACK_EMAIL_SUBJECT)}` +
    `&body=${encodeURIComponent(emailBody)}`
  );
};
